import React from "react";
import ContactForm from "../ContactForm/ContactForm";

const ContactUs = () => {
  return (
    <>
      <ContactForm></ContactForm>
    </>
  );
};

export default ContactUs;
